// API helper for DAN-TEAM STAINLESS ApS CMS integration
const API_BASE_URL = 'https://api.dev.auxo.dk';

// Robust fallbacks containing the exact scraped content
export const FALLBACK_DATA = {
  pages: {
    index: {
      title: "Din professionelle samarbejdspartner i rustfri stål · DAN-TEAM STAINLESS ApS",
      meta_title: "Din professionelle samarbejdspartner i rustfri stål · DAN-TEAM STAINLESS ApS",
      meta_description: "DAN-TEAM STAINLESS ApS er din professionelle samarbejdspartner i rustfrit stål med speciale i fremstilling, montage og supervision af procesanlæg til fødevareindustrien og kemisk industri.",
      hero_image: ["https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/55dfd408-b442-4dfe-be75-a310b44063dd.jpg"],
      content: `<p>Dan-Team Stainless er en virksomhed med speciale i fremstilling, montage og supervision af procesanlæg indenfor især fødevare og den kemiske industri.</p>
<p>Vi tager gerne hele montageopgaven med vores hold af uddannede og certificerede medarbejder, som arbejder både i Danmark men som også gennem mange år har haft store montageopgaver rundt i hele verden.</p>
<p>Siden Dan-Team Stainless startede i 1999 har vi bygget en lang række forskellige procesanlæg for blandt andet SPX Anhydro, GEA Niro, Gea Liquid Scandinavia, Carlisle Process Systems, Siccadania, Orkla Foods og Tetra Pak.</p>
<ul>
  <li><strong>DAN-TEAM er specialister i komplette montager af rustfrie anlæg: Mejerier – bryggerier – fødevareindustrien – den kemiske industri + supervision worldwide</strong></li>
  <li><strong>På DAN-TEAMs værksted fremstilles mange af komponenterne til egne montager: Tanke – units – platforme – ventilbatterier + special løsninger</strong></li>
  <li><strong>DAN-TEAM er derudover også underleverandører for flere ingeniørfirmaer.</strong></li>
</ul>
<h3>Om DAN-TEAM STAINLESS</h3>
<p>Dan-Team Stainless drives i dag af de to ejere Søren Pedersen og Martin Vedel Bindesbøl. Begge har været i branchen for produktion og montage af rustfrit stål i fødevareindustrien, igennem rigtig mange år. Martin står til dels for montage og supervision, mens Søren er leder af værkstedet.</p>
<h3>Kompetent team</h3>
<p>Alle medarbejdere er håndplukkede og certificerede efter de gældende krav til opgaverne. Alle arbejder selvstændigt, ud fra tegningsmateriale og PI diagrammer.</p>
<p>Derudover er alle medarbejder fortrolige med de strenge krav og standarder, der stilles til hygiejne og finish indenfor især fødevareindustrien. Herudover er det en selvfølge, at alle arbejder for at overholde de kundespecificerede krav.</p>`
    },
    vaerkstedet: {
      title: "Værkstedet · DAN-TEAM STAINLESS ApS",
      meta_title: "Værkstedet · DAN-TEAM STAINLESS ApS",
      meta_description: "Vi sætter en ære i altid at levere vores produkter nøjagtig tilpasset kundens ønsker og behov og ikke mindst at overholde den aftalte deadline.",
      hero_image: ["https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/712c627a-a535-4e18-86ad-bc70df05eee5.jpg"],
      content: `<h2>Vores værksted</h2>
<p>DAN-TEAM Stainless har siden 2010 haft værksted i Sjølund lidt syd for Kolding.</p>
<p>I 2015 flyttede vi til nyere lyse lokaler på Kurkmarkvej 6, stadig i Sjølund.</p>
<p>På vores fuldt udstyrede værksted, bliver du mødt af en flok dygtige og engagerede medarbejdere, som alle er uddannede i branchen og som løbende uddannes, så de altid har gældende certifikater og godkendelser. Vores stab består af 5-7 smede og to lærlinge. Vi sætter en ære i altid at levere vores produkter nøjagtig tilpasset kundens ønsker og behov og ikke mindst at overholde den aftalte deadline.</p>
<p>Vores opgaver spænder bredt, fra et beslag som en montør skal bruge ude på en montage og til nøglefærdige units klar til produktion. Ens for alle opgaver er, at vi altid sikrer at kvaliteten altid er i top.</p>
<h3>Vi er med fra første ide</h3>
<p>En af vores kerne kompetencer er at vi hjælper kunden hele vejen fra ide og design, til produktion af det færdige produkt.</p>
<p>Gennem vore mange år i branchen har vi opbygget et stort know-how indenfor fremstilling og produktion af udstyr til fødevareindustrien.</p>
<p>Vi hjælper ofte vore kunder med blandt andet, ide og design, tegningsarbejde, gennemgang af projekter inden opstart med henblik på optimering af fremstillingsprocesser, materialevalg mm.</p>
<p>Udover DAN-TEAM Stainless egne kompetencer, har vi et stort netværk af underleverandører og samarbejdspartnere, som vi har samarbejdet med gennem mange år og som kender vores krav til kvalitet, dette gælder bl.a.:</p>
<ul>
  <li>3D-tegning</li>
  <li>Laserskæring</li>
  <li>Maskinbearbejdning af emner i alle udformninger</li>
  <li>Overfladebehandling af rustfrit stål; slibning, polering, bejdsning og glasblæsning</li>
</ul>
<h3>Priser</h3>
<p>Kontakt os for et uforpligtende tilbud på din næste opgave.</p>`
    },
    montageafd: {
      title: "Montageafdelingen · DAN-TEAM STAINLESS ApS",
      meta_title: "Montageafdelingen · DAN-TEAM STAINLESS ApS",
      meta_description: "DAN-TEAM har mere end 20 års erfaring i montage af procesanlæg i de forskellige industrier.",
      hero_image: ["https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/a61c6976-2ded-460b-a358-b6f3edb3dd8f.jpg"],
      content: `<h2>Vores montageafdeling</h2>
<p>DAN-TEAM har mere end 20 års erfaring i montage af procesanlæg i de forskellige industrier samt gennemførelsen af både store og små montagearbejder.</p>
<p>Vores erfarne montører og supervisorer udfører nybyg, flytninger og renoveringer af alle typer af procesindustri og det især procesanlæg for fødevarer og den kemiske industri.</p>
<p>På baggrund af kundens anlægsspecifikationer og tegningsmateriale giver vi gerne en fast pris på opgaven, men for mindre montage- og vedligeholdelsesopgaver kan det afregnes som timelønsarbejde.</p>
<p>Ofte har kunden også brug for vores hjælp igennem processen med ideer, know-how og planlægning af opgaven. Vi har fast tegner tilknyttet huset, som vi har haft samarbejde med gennem mange år og som har en rigtig stor viden indenfor vores område.</p>
<p>DAN-TEAM Stainless stiller med et team af dygtige supervisorer, montører og svejsere, der alle er udstyret med tidssvarende værktøj, udstyr og alle de påkrævede certifikater. Vi arrangerer gerne selv rejser og ophold for vores montører og supervisorer – både nationalt og internationalt. Ved større montageprojekter medbringer vi en montagecontainer, der fungerer som et mobilt værksted samt som frokost faciliteter for vores medarbejdere.</p>
<h3>Supervision</h3>
<p>Til de opgaver, hvor kunden ønsker at benytte egne montører, kan Dan-Team Stainless tilbyde assistance fra vores dygtige supervisorer. Supervisoren leder og gennemfører montagearbejdet på basis af flowdiagrammer og arrangementstegninger, så kunden ikke selv skal bruge unødig tid på projektering og udarbejdelse af detaljerede tegninger. Vores supervisorer er danskere og taler alle engelsk og tysk.</p>
<h3>Flytninger</h3>
<p>DAN-TEAM Stainless har foretaget flere flytninger af komplette procesanlæg f.eks. fra et land til et andet.</p>
<p>Når vi har ansvaret for montageentreprisen, skal kunden ikke bekymre sig om små detaljer i forbindelse med arbejdet, dem har vi styr på.</p>`
    },
    vandskaering: {
      title: "Vandskæring · DAN-TEAM STAINLESS ApS",
      meta_title: "Vandskæring · DAN-TEAM STAINLESS ApS",
      meta_description: "Fordelene ved vandstråleskæring er, at mange emner kan anvendes direkte fra skæreprocessen uden nogen videre efterbearbejdning.",
      hero_image: ["https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/67dab333-1d05-448c-b845-f04bf23c83c8.jpeg"],
      content: `<h2>Vandskæring – et tryk på 4000 bar</h2>
<p>Har du brug for vandskæring/vandstråleskæring, kan vi være behjælpelig, Vi har udført vandskæring for en bred vifte af kunder fra hele Danmark, der tæller både private og erhverv.</p>
<p>Teknologien bag Abrasiv vandskæring tager udgangspunkt i højtrykspumpen, her bliver vandet tilført et tryk på 4000 bar. Ved skærehovedet bliver der tilsat et fint slibemiddel, derved kan der vådslibes gennem stort set alle materialer.</p>
<p>Fordelene ved vandstråleskæring er, at mange emner kan anvendes direkte fra skæreprocessen uden nogen videre efterbearbejdning.</p>
<p>Kræves der derimod en efterbearbejdning, er der ingen hærdede zoner, som slider meget på skærende værktøjer.</p>
<p>Skæreprocessen is “kold”, dvs. at der ikke sker varmepåvikninger / randzonehærdninger under skæringen.</p>
<p>Det betyder også, at man i mange tilfælde kan skære gevind i skårne huller, uden at skulle bore hullet op først.</p>
<p>Udover stor nøjagtighed er nogle af fordelene ved vandskæring, at man opnår en konkurrencedygtig og miljøvenlig løsning samt ingen eller minimal afgratning.</p>
<h3>Næsten ingen begrænsninger</h3>
<p>Udover stor nøjagtighed er nogle af fordelene ved vandskæring, at man opnår en konkurrencedygtig og miljøvenlig løsning samt ingen eller minimal afgratning.</p>
<h5>Vi tilbyder vandskæring af følgende materialer:</h5>
<ul>
  <li>Rustfrit stål</li>
  <li>Aluminium</li>
  <li>Kobber</li>
  <li>Messing</li>
  <li>Zink</li>
  <li>Titan</li>
  <li>Keramik</li>
  <li>Beton</li>
  <li>Gummi</li>
  <li>Plast</li>
  <li>Glasfiber</li>
  <li>Vinyl</li>
  <li>Træ</li>
  <li>Glas</li>
  <li>Dit materiale..??</li>
</ul>
<p>Programmer til vandstråleskæring udarbejdes på baggrund af papirstegninger, eller kundens pdf, dxf, stp eller dwg filer.</p>
<p>Kontakt vedr. Vandskæring, soren@dan-team.com</p>`
    },
    "om-os": {
      title: "Om os · DAN-TEAM STAINLESS ApS",
      meta_title: "Om os · DAN-TEAM STAINLESS ApS",
      meta_description: "Dan-Team Stainless er en virksomhed med speciale i montage og supervision af procesanlæg indenfor især fødevare og den kemiske industri.",
      hero_image: ["https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/3c7c8695-9864-43de-a701-a08552981bd0.jpg"],
      content: `<h2>Om os</h2>
<p>Dan-Team Stainless drives i dag af de to ejere Søren Pedersen &amp; Martin Vedel Bindesbøl, som begge har været i branchen for produktion og montage af rustfrit stål i fødevareindustrien gennem rigtig mange år. Martin står for montage og supervision, mens Søren er leder af værkstedet.</p>
<p>Dan-Team Stainless er en virksomhed med speciale i montage og supervision af procesanlæg indenfor især fødevare og den kemiske industri. Vi tager gerne hele montageopgaven med vores hold af uddannede og certificerede medarbejdere, som arbejder både i Danmark, men som også gennem mange år har haft store montageopgaver rundt i hele verden. Siden Dan-Team Stainless startede i 1999, har vi bygget en lang række forskellige procesanlæg for blandt andet SPX Anhydro, GEA Niro, Gea Liquid Scandinavia, Carlisle Process Systems, Sicca dania, Orkla Foods og Tetra Pak.</p>
<p>Alle medarbejdere er håndplukkede og certificerede efter gældende krav til opgaverne og alle arbejder selvstændigt ud fra tegningsmateriale og PI diagrammer. Derudover er alle medarbejder fortrolige med de strenge krav og standarder, der stilles til hygiejne og finish, indenfor især fødevareindustrien og det er en selvfølge, at alle arbejder for at overholde de kundespecificerede krav. For os es det vigtigt at en montageopgave nås til deadline og at alle krav overholdes og derfor vil mester selv også være med på opgaven som arbejdende supervisor.</p>
<p>Kræver montageopgaven derimod at kunden vil bruge egne håndværkere kan Dan-Team Stainless tilbyde en supervisor til at styre opgaven.</p>
<p>Siden 2009 har Dan-Team Stainless også haft et fuldt udstyret værksted til produktion af blandt andet procesudstyr til fødevareindustrien. Her fremstiller veluddannede medarbejdere alt fra præfabrikerede dele til montageopgaverne, til nøglefærdige units klar til installation samt diverse underleverandørarbejde til adskillige leverandører til fødevareindustrien.</p>
<h3>Historie</h3>
<p>Dan-Team Stainless blev grundlagt i 1999 af de to brødre Ib Rasmussen og Kim Rasmussen. I 2014 Indtræder Søren Pedersen som medejer i firmaet efter at have været ansat i firmaet gennem flere år. I januar 2017 fusionerer Dan-Team Stainless med MVB Steel og indehaver Martin Vedel Bindesbøl indtræder som medejer i Dan-Team Stainless.</p>`
    },
    referencer: {
      title: "Referencer · DAN-TEAM STAINLESS ApS",
      meta_title: "Referencer · DAN-TEAM STAINLESS ApS",
      meta_description: "Siden Dan-Team Stainless startede i 1999 har vi bygget en lang række forskellige procesanlæg for virksomheder.",
      hero_image: ["https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/ddd6ef51-f3db-400f-bf9b-d1d8ddae8c3d.jpg"],
      content: `<h2>Vores referencer</h2>
<p>Siden Dan-Team Stainless startede i 1999 har vi bygget en lang række forskellige procesanlæg for virksomheder.</p>`
    },
    nyheder: {
      title: "Seneste oplæg · DAN-TEAM STAINLESS ApS",
      meta_title: "Seneste oplæg · DAN-TEAM STAINLESS ApS",
      meta_description: "Se vores projekter her.",
      hero_image: ["https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/6ccf7eb1-0ddd-4c73-aab3-801631a74b5c.jpg"],
      content: `<h2>Seneste oplæg</h2>
<p>Se vores projekter her.</p>`
    },
    kontakt: {
      title: "Kontakt · DAN-TEAM STAINLESS ApS",
      meta_title: "Kontakt · DAN-TEAM STAINLESS ApS",
      meta_description: "Har du spørgsmål eller kommentarer?",
      hero_image: ["https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/55dfd408-b442-4dfe-be75-a310b44063dd.jpg"],
      content: `<h2>Kontakt</h2>
<p>Har du spørgsmål eller kommentarer?</p>`
    },
    "information-in-english": {
      title: "Information in English · DAN-TEAM STAINLESS ApS",
      meta_title: "Information in English · DAN-TEAM STAINLESS ApS",
      meta_description: "Here you can see our contact information. Please contact us for any questions or enquiries.",
      hero_image: ["https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/55dfd408-b442-4dfe-be75-a310b44063dd.jpg"],
      content: `<h2>Information in English</h2>
<p>Here you can see our contact information. Please contact us for any questions or enquiries.</p>
<h3>Our information</h3>
<p><strong>DAN-TEAM STAINLESS ApS</strong></p>
<p>Kurkmarkvej 6, 6093 Sjølund</p>
<p>(+45) 76 99 10 20</p>
<p>info@dan-team.com</p>
<p>CVR nr.: 21670405</p>
<h3>Opening hours</h3>
<p>Monday – thursday: 6.30 – 16.00</p>
<p>Friday: Closed</p>
<p>Saturday and sunday: Closed</p>
<h3>Fynske Bank</h3>
<p>Reg. nr. 6854</p>
<p>Konto. nr. 1127046</p>
<p>IBAN: DK0368540001127087</p>
<p>SWIFT code: VESBDK22</p>`
    }
  },
  galleries: {
    "gallery-om-os": [
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/0068d57e-e59d-413c-9aa0-a0295079401b.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/712c627a-a535-4e18-86ad-bc70df05eee5.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/a41d2803-e924-4a3e-b722-2af2382e73be.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/dc04feda-8e29-457f-b216-4abb9d3f4eb6.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/adede339-5a37-49ba-ba4e-d8f78fe85d12.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/13e4a13e-805b-48b8-9641-0226574fddee.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/bd4b7bb2-b4b3-4686-b5de-4f9f14269e5c.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/c1f7a3bc-714a-44be-b366-b6f8a1414642.jpg"
    ],
    "gallery-vaerkstedet": [
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/cc1b2b76-a3ab-4522-9fa6-1d48d7e2cc3c.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/cffb3a15-8505-4943-a05b-2be0547b5665.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/2b5ed721-9e94-481d-a70d-6fff6ada550e.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/3c7c8695-9864-43de-a701-a08552981bd0.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/c6dcf391-e06f-418e-afa6-1a28610831a6.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/eac556f1-ebf8-4898-b7e4-c0dff46c3d7c.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/ec46109f-1462-45a0-bb36-243c070682af.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/fd3b2840-09f7-4139-96c0-cfbac11ced2f.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/f267b947-28d9-40a6-bd1e-94dd13b1fdf3.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/58cae7c5-6857-43a4-8407-334c38bcc3e3.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/c6651afa-97eb-4faf-837b-e90180db79c3.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/ddd6ef51-f3db-400f-bf9b-d1d8ddae8c3d.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/55dfd408-b442-4dfe-be75-a310b44063dd.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/a3b7280b-909b-4a81-8738-eed0f1885e2d.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/c1f7a3bc-714a-44be-b366-b6f8a1414642.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/bd4b7bb2-b4b3-4686-b5de-4f9f14269e5c.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/9efc7b4f-2aa2-4ee9-b272-ffedad51ba2d.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/2eb92630-b087-4405-863d-49fbe10891e7.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/13e4a13e-805b-48b8-9641-0226574fddee.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/adede339-5a37-49ba-ba4e-d8f78fe85d12.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/dc04feda-8e29-457f-b216-4abb9d3f4eb6.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/a41d2803-e924-4a3e-b722-2af2382e73be.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/712c627a-a535-4e18-86ad-bc70df05eee5.jpg"
    ],
    "gallery-montageafd": [
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/bfa4be7f-90e2-4e43-93f6-32af100d5f5e.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/b3d62c9e-7350-42f0-9fe3-0e1d8aedbb8b.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/0d881abc-ac28-4a4e-8a0d-e977294eaba9.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/6d5d3d3f-5211-4d49-983e-3f74cac72d2c.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/89c981e5-5d7a-4df8-b49a-f9ebed1e9c10.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/b4f33bff-cbe6-4fe6-9a4b-0d46b73c6915.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/c3182d4d-ec9f-43ea-b278-fe5c0bb99fd5.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/ada2af39-d7d1-4924-a6f6-bdaeaea64943.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/ba5013f6-eebd-4389-903c-4161d5fd0c25.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/6f17cb1c-591a-4c64-856a-ffb55418067c.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/4cc19c16-2b2b-46e6-8866-73bdabf5d873.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/3beb603b-679c-41b1-9afd-0b25f63c102f.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/a23d4e9b-648f-46a2-af1e-3acb15c9a2eb.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/a1e52079-9c90-408d-ba7b-ce76bd055ffc.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/72f7b839-4573-4e93-93d0-3626e36e95fa.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/154591bc-4df7-4a66-9560-14063239dd00.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/66d9d716-76df-484b-a096-f8b2cc4a508f.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/c2722978-f38c-4f2a-9b45-dfc6e1cf28c8.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/26fcea28-1638-41b8-b4d8-8cd55b50cfa8.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/7961b50e-5a74-4111-8592-c4719db40d0d.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/ff6afe6d-2716-4452-9abe-28f523b09b1d.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/c71e0801-1578-45f5-8308-6302c7493ea3.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/b08d8782-46db-4e84-a13d-f5a59f33c566.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/23b68330-58a0-404e-a0fc-5a264d2d911c.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/ea0b03fe-b244-48be-9d2f-7bdc0ea55cc4.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/b7c0dcf6-cdfb-44fb-b9e7-fefbc3bc681d.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/533a938f-a042-4e93-bd28-56bc0eec6615.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/a65d2879-925d-4f75-8df9-61337ede11dd.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/4e9e09fc-33c0-491c-9da1-14ef2e25dbd0.jpg"
    ],
    "gallery-vandskaering": [
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/b855e636-4256-4087-bd53-e98d164defa8.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/ebee3596-500b-4483-b290-c9cd540d38d3.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/beb7816c-984b-4747-975d-92598dda54fd.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/b364cc81-23d7-4b44-b4c0-8f5f10bd8a9d.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/010d7455-fa26-44bc-a550-364e8f5854f0.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/3cf17862-3155-43fa-996b-5dc4417d566f.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/6ed78c4e-9612-4a01-a000-5942bff48be6.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/907efa1f-9382-4bf9-bb53-154cf7e354d7.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/3fb7091d-4113-43ac-932d-65e8c9e8b76e.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/b1004d13-24c0-4154-a772-1e79d580fe1e.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/af5441d1-63e8-4159-99ba-d0cf1e5970d2.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/6029334d-1fb0-44b4-a4e0-f93925a5db33.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/db527e03-0861-4f5d-86e0-7b61c1a467ed.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/a6340035-0b84-4129-a282-b46eda7f5943.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/a08f65f2-cc8e-45d5-aa22-ecbc1ccf1e07.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/3e813b84-51be-4db9-977a-12da33d5a7f5.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/4cb03e6d-a5aa-4514-aefe-5488a979562a.jpeg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/6ca891e6-3a0f-402e-b622-bef4b2d5c7eb.jpeg"
    ],
    "gallery-referencer": [
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/c7b8daa6-9961-4587-84d3-96b9ccb64b31.png",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/914f2daa-4969-469b-a900-f59ce2cbfbe5.png",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/3c0b910f-cd4d-409e-9768-4dce6d3bb86e.png",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/eaab5824-91f0-46d1-a9c7-5e8ef68d0a9c.png",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/a7e81b7f-cc34-4976-b7e0-88bf132acc15.png",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/cb59b36d-52f4-481a-b3e6-90b8ed405e42.png",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/d958be7e-f61f-466b-b0f2-a51679a1d02c.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/20d692d3-81dc-4519-9de3-28a278283713.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/bebf54ee-9117-451f-9068-edcc8fec6b78.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/c6a98947-793c-4724-bb76-97e91d7c9d08.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/6f975927-140c-402e-99f0-17d8b93e9f5b.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/6d832815-0841-4c37-821a-41e5cf0c6739.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/f07004ae-a097-4ac9-bd78-656375ea15c1.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/d2cb68dd-e2f6-4781-96a2-3e0f02f1efaf.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/6acb491d-dbf0-4f04-b749-07b9342f98bc.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/d731839f-a22d-4e3b-8ae7-569c8394d395.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/70e1dbbc-2e4c-4e60-a5a1-14afe146c1f3.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/003aec3f-2831-46e2-8f7c-902968fc596a.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/a9fbb1ed-a890-4e93-ac29-40c464101532.jpg",
      "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/feccd656-9d79-4408-81c8-b27f3520a2f6.jpg"
    ]
  },
  news_posts: [
    {
      id: "vejebeholder",
      slug: "vejebeholder",
      title: "Vejebeholder",
      date: "15. december 2022",
      summary: "En lille vejebeholder til en vores trofaste nordiske kunder.",
      content: "<p>En lille vejebeholder til en vores trofaste nordiske kunder.</p>",
      images: [
        "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/bbb1a3a3-a151-48b2-ae48-5dc818aaa632.bin",
        "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/57d8b163-0993-424e-b67c-909dcf615e62.jpeg",
        "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/a8074317-2a2d-441c-a155-01ceab168932.jpeg"
      ]
    },
    {
      id: "cykloner",
      slug: "cykloner",
      title: "Cykloner",
      date: "5. december 2022",
      summary: "2 stk. Cykloner klar til afsendelse Kunden havde under service på deres anlæg opdaget at deres cykloner var slidt igennem flere steder, derfor skulle de 2 nye Cykloner fremstilles hurtigt. 3 uger fra ordremodtagelse til afsendelse fra Værkstedet = glade kunder.",
      content: "<p>2 stk. Cykloner klar til afsendelse</p><p>Kunden havde under service på deres anlæg opdaget at deres cykloner var slidt igennem flere steder, derfor skulle de 2 nye Cykloner fremstilles hurtigt.</p><p>3 uger fra ordremodtagelse til afsendelse fra Værkstedet = glade kunder.</p>",
      images: [
        "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/6ccf7eb1-0ddd-4c73-aab3-801631a74b5c.jpg",
        "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/efd76977-4742-435a-8b79-0318108a3942.jpeg",
        "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/0c356755-4697-4c53-87f7-25fa5c36dc5f.jpeg",
        "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/af3a9730-f65b-4f86-935d-7585fb5d699f.jpeg",
        "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/b5264066-3494-4c69-9c61-4785801880b3.jpeg"
      ]
    },
    {
      id: "udskiftning-af-tanke-og-roer-paa-cipunit",
      slug: "udskiftning-af-tanke-og-roer-paa-cipunit",
      title: "Udskiftning af tanke og rør på CIPUNIT",
      date: "28. september 2021",
      summary: "Se flere af vores projekter og referencer her.",
      content: "<p>En af vores gode kunder havde et ældre Cipanlæg hvor tanke og rør var gennemtæret. Nye tanke blev fremstillet og rør og tanke udskiftet hos kunden.</p>",
      images: [
        "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/130c4bc7-0e82-4777-8cfd-6232910d0a04.jpeg",
        "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/48f9eebb-7fea-49de-bed9-0f812d81aeae.jpeg",
        "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/501f05ba-8aad-4362-a17e-8190c6088a09.jpeg",
        "https://assets.auxodev.dk/assets/814e446f-d222-4d23-8be7-5a6a25bb15ff/724de25d-068b-4dd4-98b4-42360be09968.jpeg"
      ]
    }
  ]
};

// Helper to extract localized text
export function getLocalized(field, lang = 'da') {
  if (!field) return '';
  if (typeof field === 'string') return field;
  return field[lang] || field['da'] || '';
}

// Fetch a single page by slug
export async function fetchPageBySlug(slug, lang = 'da') {
  try {
    const response = await fetch(`${API_BASE_URL}/public/by-slug/${lang}/${slug}`);
    if (response.ok) {
      const data = await response.json();
      return {
        title: getLocalized(data.title, lang),
        meta_title: getLocalized(data.meta_title, lang),
        meta_description: getLocalized(data.meta_description, lang),
        content: getLocalized(data.content, lang),
        hero_image: data.hero_image || []
      };
    }
  } catch (error) {
    console.warn(`Failed to fetch page "${slug}" from CMS, using fallback:`, error);
  }

  // Fallback
  const fallback = FALLBACK_DATA.pages[slug];
  if (fallback) {
    return {
      title: fallback.title,
      meta_title: fallback.meta_title,
      meta_description: fallback.meta_description,
      content: fallback.content,
      hero_image: fallback.hero_image
    };
  }

  return null;
}

// Fetch a gallery by slug
export async function fetchGalleryBySlug(slug, lang = 'da') {
  try {
    const response = await fetch(`${API_BASE_URL}/public/by-slug/${lang}/${slug}`);
    if (response.ok) {
      const data = await response.json();
      return data.images || [];
    }
  } catch (error) {
    console.warn(`Failed to fetch gallery "${slug}" from CMS, using fallback:`, error);
  }

  // Fallback
  return FALLBACK_DATA.galleries[slug] || [];
}

// Fetch all news posts
export async function fetchAllNewsPosts(lang = 'da') {
  try {
    const response = await fetch(`${API_BASE_URL}/public/content/news_posts`);
    if (response.ok) {
      const data = await response.json();
      return data.map(post => ({
        id: post.id,
        slug: getLocalized(post.slug, lang) || post.id,
        title: getLocalized(post.title, lang),
        date: getLocalized(post.date, lang),
        summary: getLocalized(post.summary, lang),
        content: getLocalized(post.content, lang),
        images: post.images || []
      }));
    }
  } catch (error) {
    console.warn('Failed to fetch news posts from CMS, using fallback:', error);
  }

  // Fallback
  return FALLBACK_DATA.news_posts;
}

// Fetch a single news post by slug
export async function fetchNewsPostBySlug(slug, lang = 'da') {
  try {
    const response = await fetch(`${API_BASE_URL}/public/by-slug/${lang}/${slug}`);
    if (response.ok) {
      const data = await response.json();
      return {
        id: data.id,
        slug: slug,
        title: getLocalized(data.title, lang),
        date: getLocalized(data.date, lang),
        summary: getLocalized(data.summary, lang),
        content: getLocalized(data.content, lang),
        images: data.images || []
      };
    }
  } catch (error) {
    console.warn(`Failed to fetch news post "${slug}" from CMS, using fallback:`, error);
  }

  // Fallback
  const fallback = FALLBACK_DATA.news_posts.find(post => post.slug === slug);
  if (fallback) {
    return fallback;
  }

  return null;
}
